"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ModalContentDesktop = require("./ModalContentDesktop");
Object.keys(_ModalContentDesktop).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ModalContentDesktop[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ModalContentDesktop[key];
    }
  });
});